import React from 'react';

import { Center, Flex, Paper, Stack, Text } from '@mantine/core';
import { DroxyBoxedIcon } from 'components/Droxy/DroxyBoxedIcon';

interface DroxySelectCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  isSelected: boolean;
  onSelect: () => void;
}

export function DroxySelectCard({ title, description, icon, isSelected, onSelect }: DroxySelectCardProps) {
  return (
    <Paper
      p="xl"
      sx={(theme) => ({
        borderRadius: theme.radius.md,
        cursor: 'pointer',
        backgroundColor: isSelected ? theme.colors.gray[0] : 'white',
        border: `1px solid ${isSelected ? theme.colors.gray[4] : theme.colors.gray[2]}`,
        '&:hover': {
          backgroundColor: theme.colors.gray[0]
        }
      })}
      onClick={onSelect}>
      <Stack spacing="md">
        <Center>
          <DroxyBoxedIcon icon={icon} isCircular size={48} />
        </Center>

        <Flex direction="column" align="center">
          <Text size="lg" weight={600} align="center">
            {title}
          </Text>

          <Text color="dimmed" align="center" mt="sm">
            {description}
          </Text>
        </Flex>
      </Stack>
    </Paper>
  );
}
